import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';

import { MatPaginatorOnDemandComponent } from './mat-paginator-on-demand.component';

@NgModule({
  declarations: [MatPaginatorOnDemandComponent],
  exports: [MatPaginatorOnDemandComponent],
  imports: [
    CommonModule, MatPaginatorModule, MatSelectModule, FormsModule, ReactiveFormsModule, FlexLayoutModule, MatInputModule, MatTooltipModule
  ]
})
export class MatPaginatorOnDemandModule { }
